import { useTheme } from "@mui/material/styles";
import { useMatchQuery } from "./useMatchQuery.js";
const useIsDesktopExtraLarge = ()=>{
    const theme = useTheme();
    return useMatchQuery(theme.breakpoints.up('xl'));
};
export { useIsDesktopExtraLarge };
